// Imports
import React from "react"
import { useLocation } from "react-router-dom"
import { Font, Button, Section, Table } from "fajny-react"
import { v4 as uuid } from "uuid"
import { slugify, unslugify } from "js-utils-julseb"

import PageLayout from "./PageLayout"
import CodeContainer from "./CodeContainer"
import DemoItem from "./DemoItem"

import allComponentsPages from "../data/all-components-pages"

const ComponentPage = ({ children, items, propsItems }) => {
    const location = useLocation().pathname
    const category = location.split("/")[1]
    const componentName = location.split("/")[2]

    const pageComponent = allComponentsPages.filter(component =>
        slugify(component.title).includes(slugify(componentName))
    )[0]

    return (
        <PageLayout title={unslugify(pageComponent.title)}>
            <Button
                to={`/${category}`}
                fajnyIconLeft="arrow-left-solid"
                buttonStyle="text"
                noPadding
            >
                Back to list
            </Button>

            <Font.H1>{unslugify(pageComponent.title)}</Font.H1>

            {pageComponent.intro &&
                (typeof pageComponent.intro === "string" ? (
                    <Font.P>{pageComponent.intro}</Font.P>
                ) : (
                    pageComponent.intro
                ))}

            {pageComponent.include && (
                <Section gap="small">
                    <Font.H3>
                        File
                        {pageComponent.include.split(",").length > 1
                            ? "s"
                            : ""}{" "}
                        to include
                    </Font.H3>

                    <CodeContainer>
                        {`import { ${pageComponent.include} } from "fajny-react"`}
                    </CodeContainer>
                </Section>
            )}

            {children}

            {items && items.map(item => <DemoItem demo={item} key={uuid()} />)}

            {propsItems && (
                <Section gap="small">
                    <Font.H3>Props</Font.H3>

                    <Table tableStyle="stripped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Example value</th>
                                <th>Possible values</th>
                                <th>Default</th>
                                <th>Required</th>
                            </tr>
                        </thead>

                        <tbody>
                            {propsItems.map(item => (
                                <tr key={uuid()}>
                                    <td>{item.name}</td>
                                    <td>{item.type}</td>
                                    <td>
                                        {item.type === "Boolean"
                                            ? "-"
                                            : item.example || "-"}
                                    </td>
                                    <td>
                                        {item.type === "Boolean"
                                            ? "-"
                                            : item.possible || "-"}
                                    </td>
                                    <td>
                                        {item.type === "Boolean" &&
                                        !item.default
                                            ? "false"
                                            : item.default || "None"}
                                    </td>
                                    <td>{item.required || "No"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>
            )}
        </PageLayout>
    )
}

export default ComponentPage
